//imports
import './style.scss';
import React from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { Image, RichText, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { renderDate } from '../Shared/Helpers/dateTimeHelper';
import Button from '../Shared/components/controls/Button';

//component
const HeaderBannerOfferDetailedComponent = (props) => {
  const context = useSitecoreContext();

  if (!context?.sitecoreContext?.route.fields) {
    return <GenericPlaceholder componentName="HeaderBannerOfferDetailedComponent" />;
  }
  //-->language
  const { t: translate, i18n, params } = props;
  const lang = i18n.language;
  //translation
  const txt_nonExpiringOffer = translate('nonExpiringOffer');
  const txt_endsIn = translate('offerValidity');

  const {
    offerHeroImage: image,
    merchantName: title,
    validityEnd,
    offerLogo: logo,
    offerHighlight: description,
  } = context?.sitecoreContext?.route.fields;

  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderLogo = !!logo?.value?.src;
  const shouldRenderTitle = !!title?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderOfferValidity = !!validityEnd?.value;
  const shouldRenderValidityEnd = !!validityEnd?.value && !validityEnd?.value?.startsWith('0001');

  const { backLink } = context?.sitecoreContext?.route.fields;
  const { disableBackLink } = props.params;

  const shouldRenderBacklink = !!backLink?.value?.href;
  // link setup link else referrel else history.back(-1)

  const BackButton = ({ link }) => {
    let customLink = {
      value: {
        StyleDropdown: 'button-text-primary-arrow-left',
        class: 'button-text-primary-arrow-left',
        href: !!link?.value?.href ? link?.value?.href : 'javascript:history.back(-1)',
        text: translate('Back'),
      },
    };
    return <Button link={customLink} className="inverted-arrow" />;
  };
  //return data
  return (
    <div className={clsx('HeaderBannerOfferDetailedSection', 'add-margins', params?.Styles)}>
      <div className="content full-content-mobile">
        <div className="tags-block">
          <div className="wrap">
            <div className="tags-content flex-it flex-align-item-end">
              {shouldRenderImage && (
                <figure>
                  <Image field={image} />
                </figure>
              )}
              <div className="auto">
                {shouldRenderTitle && <div className="title">{title?.value}</div>}
                {shouldRenderDescription && (
                  <RichText className="description" field={description} />
                )}
                {shouldRenderOfferValidity && (
                  <div className="offer-text flex-it">
                    <span className="icon flex-align-item-center">
                      <img
                        src="/-/jssmedia/Project/FAB2/shared/images/ico_white-clock.svg"
                        alt=""
                      />
                    </span>
                    {shouldRenderValidityEnd && (
                      <span className="text">
                        {txt_endsIn.replace('{0}', renderDate(validityEnd?.value, lang, 'm d, y'))}
                      </span>
                    )}
                    {!shouldRenderValidityEnd && (
                      <span className="text">{txt_nonExpiringOffer}</span>
                    )}
                  </div>
                )}
              </div>
            </div>
            {shouldRenderLogo && (
              <div className="logo-content flex-it flex-align-item-end">
                <div className="logo-wrap flex-it">
                  <Image field={logo} />
                </div>
              </div>
            )}
          </div>
          {disableBackLink === undefined &&
            (shouldRenderBacklink ? (
              <BackButton link={backLink} className="inverted-arrow" />
            ) : (
              <BackButton link={backLink} className="inverted-arrow" />
            ))}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(HeaderBannerOfferDetailedComponent);
